module.exports = __webpack_public_path__ + "static/media/article-layout-one.ffca93ae.jpg";